<template>

	<b-form-radio-group
	size="lg"
	:options="displayOptions"
	stacked
	/>

</template>

<script>
	export default {
		props:{
			"data":Object
		},
		computed:{
			displayOptions(){
				let options = this.data.settings.options;
				return options.map(o => {
					return {
						text: o,
						value: o
					}
				})
			}
		}
	}
</script>